import { render, staticRenderFns } from "./SkillsEvaluation.vue?vue&type=template&id=668bc8d2&scoped=true"
import script from "./SkillsEvaluation.vue?vue&type=script&lang=js"
export * from "./SkillsEvaluation.vue?vue&type=script&lang=js"
import style0 from "./SkillsEvaluation.vue?vue&type=style&index=0&id=668bc8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bc8d2",
  null
  
)

export default component.exports